export default "__VITE_ASSET__77c28a9e__"